<div style="height: 100%; flex-direction: column; box-sizing: border-box; display: flex;" class="page-container mat-app-background">

  <!-- Header - Top Menu -->
  <div *ngIf="showHeader" style="flex-direction: column; box-sizing: border-box; display: flex;">
    <div style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;" class="page-header mat-elevation-z3">
      <div>
        <div *ngIf="showLeftMenu()">
          <lex-menu class="menu"></lex-menu>
        </div>
      </div>
      <div style="display:flex; align-items:center;">
		  <lex-right-menu></lex-right-menu>
      </div>
    </div>
    <div style="background-color:#FFC107; color: rgba(0, 0, 0, 0.84); font-size: 12px; padding: 10px 5px 5px 5px; width: 100%; text-align: center;" *ngIf="notificationHubSdk.systemNotifications?.length">
      <ng-container *ngFor="let msg of notificationHubSdk.systemNotifications; let isLast = last">
        {{msg}}<br *ngIf="!isLast">
      </ng-container>
    </div>
  </div>

  <!-- Body -->
  <div style="flex: 1 1 0%; box-sizing: border-box;" class="page-body">
    <router-outlet></router-outlet>
  </div>

  <!-- Footer -->
  <div *ngIf="showFooter" style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center;" class="page-footer">
    <a ID="hlMasterServicesAgreement" class="services-agreement" href="https://lexbe.com/master-services-agreement/" target="_blank">{{servicesAgreement}}</a>
  </div>

</div>
